module.exports = __webpack_public_path__ + "img/ueber-mich-1_1596.fa8326a6.jpg";